import React from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Latestupdate() {
  const { settings } = useSelector((state) => state?.Login);

  return (
    <section className="latest-update">
      <Container>
        <div className="form-here">
          <Link to="/">
            <div className="logo-col">
              <img
                src={settings?.logo?.link || "images/logo.gif"}
                alt=""
                className="img-fluid"
              />
            </div>
          </Link>
          {/* <div className="form-here-bottom mt-4">
            <h3>Get the latest Updates</h3>
            <Form onSubmit={onSubmit}>
              <FormGroup>
                <Input
                  type="email"
                  name="email"
                  placeholder="Enter your email id"
                />
                <Button className="subscribe-btn">Subscribe</Button>
              </FormGroup>
            </Form>
          </div> */}
        </div>
      </Container>
    </section>
  );
}
